import { Fragment, useCallback, useState } from 'react';
import Table from 'shell/components/shared/table';
import { BaseTableRows, HeadCell } from 'shell/components/shared/table/types';
import { noop } from 'shell/utils/noop';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { EventProcessingJob } from 'shell/models/job-execution';
import { Typography } from '@mui/material';

export interface ErrorsItemVM extends BaseTableRows, EventProcessingJob {
  action?: string;
}

const headCells: HeadCell<ErrorsItemVM, keyof ErrorsItemVM>[] = [
  {
    id: 'event',
    label: 'Evento',
    colSpan: 3,
  },
  {
    id: 'receivedAt',
    label: 'Data e Ora di ricezione',
    colSpan: 3,
  },
  {
    id: 'message',
    label: 'Descrizione',
    colSpan: 6,
  },
];

interface ErrorsTableProps {
  body: Array<ErrorsItemVM>;
}

const ErrorsTable = ({ body }: ErrorsTableProps): React.ReactElement => {
  const [page, setPage] = useState<number>(0);

  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  const handleChangePage = useCallback(
    (newPage) => {
      setPage(newPage);
    },
    [setPage]
  );

  const handleChangeRowsPerPage = useCallback(
    (rows) => {
      setRowsPerPage(rows);
    },
    [setRowsPerPage]
  );

  return (
    <Fragment>
      <PmiTitleDivider>Lista segnalazioni</PmiTitleDivider>
      {body ? (
        body?.length > 0 ? (
          <Table
            head={headCells}
            onSort={noop}
            orders={{}}
            page={page}
            rowsPerPage={rowsPerPage}
            body={body}
            onVisibilityPress={noop}
            onEditPress={noop}
            onTrashPress={noop}
            count={body.length}
            hideButtons
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ariaLabel="Lista Segnalazioni"
            noSort
          />
        ) : (
          <Typography color="secondary.main">
            Nessun elemento trovato con la ricerca effettuata.
          </Typography>
        )
      ) : undefined}
    </Fragment>
  );
};

ErrorsTable.displayName = 'Errors List';

export default ErrorsTable;
